import React, {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import Overview from "./Overview"
import Datasheet from "./Datasheet";
import './App.css';

export default function App() {
  const history = useHistory();

  const [state, setState] = useState("uebersicht");
  // const setURLParams = (queryState) => {
  //   const urlParams = new URLSearchParams();
  //   urlParams.set("state", queryState);
  //   history.push(`?${urlParams.toString()}`);
  //   setState(queryState);
  // };

  useEffect(() => {
    let mounted = true;
    if (mounted){
      const urlParams = new URLSearchParams( window.location.search );
      const paramState = urlParams.get("status") || "uebersicht";
      history.push(`?status=${paramState}`);
      setState(paramState);
    };
    return () => { mounted = false }

  },[history]);

  return (
    <div>
      { state==="uebersicht" && <Overview/> }
      { state==="datenblatt" && <Datasheet/>}
    </div>
  );

};
